import { min } from "lodash";
import { useEffect, useState } from "react";
import ApiConfig from "./api/ApiConfig";
import { simpleGetCallWithToken } from "./api/ApiServices";

export const getDateddmmyyyy = (inputDate) => {
  let formDate = new Date(inputDate);
  var date = formDate.getDate();
  var month = formDate.getMonth() + 1;
  var year = formDate.getFullYear();

  let formatedDate = `${date < 10 ? 0 : ""}${date}-${month < 10 ? 0 : ""
    }${month}-${year}`;
  return formatedDate;
};

export const getDateYYYYMMDD = (inputDate) => {
  let formDate = new Date(inputDate);
  var date = formDate.getDate();
  var month = formDate.getMonth() + 1;
  var year = formDate.getFullYear();

  var formatedDate = "";
  return (formatedDate = `${year}/${month}/${date}`);
};

export const getDateDashYYYYMMDD = (inputDate) => {
  let formDate = new Date(inputDate);
  console.log("formDate", formDate);
  var date = formDate.getDate();
  var month = formDate.getMonth() + 1;
  var year = formDate.getFullYear();

  var formatedDate = "";
  return (formatedDate = `${year}-${month}-${date}`);
};

export const getDateDashDDMMYYYY = (inputDate) => {
  let formDate = new Date(inputDate);
  var date = formDate.getDate();
  var month = formDate.getMonth() + 1;
  var year = formDate.getFullYear();

  var formatedDate = `${date < 10 ? 0 : ""}${date}-${month < 10 ? 0 : ""
    }${month}-${year}`;
  return formatedDate && formatedDate;
};

export const getDatemmddyyyy = (date) => {
  let formDate = new Date(date);
  var date1 = formDate.getDate();
  var month = formDate.getMonth() + 1;
  var year = formDate.getFullYear();

  var formatedDate = "";
  return (formatedDate = `${month}/${date1}/${year}`);
};

export const getDDateddmmyyyy = (inputDate) => {
  var splittedDate = inputDate.slice(0, 10).split("/").join("-");

  let formDate = new Date(splittedDate);
  var formatedDate = "";
  var date = formDate.getDate();
  var month = formDate.getMonth() + 1;
  var year = formDate.getFullYear();

  return (formatedDate = `${date < 10 ? "0" : ""}${date}-${month < 10 ? "0" : ""
    }${month}-${year}`);
};

export const getDDateyyyymmdd = (inputDate) => {
  var splittedDate = inputDate.slice(0, 10).split("/").join("-");
  let formDate = new Date(splittedDate);
  var formatedDate = "";
  var date = formDate.getDate();
  var month = formDate.getMonth() + 1;
  var year = formDate.getFullYear();
  formatedDate = `${year}-${month < 10 ? 0 : ""}${month}-${date < 10 ? 0 : ""
    }${date}`;
  return formatedDate;
};

export const getDateddmmyyyyInDash = (inputDate) => {
  var splittedDate = inputDate.slice(0, 10).split("/").join("-");

  let formDate = new Date(splittedDate);
  var formatedDate = "";
  var date = formDate.getDate();
  var month = formDate.getMonth() + 1;
  var year = formDate.getFullYear();

  return (formatedDate = `${date}-${month}-${year}`);
};

export const getDDateYYYYMMDD = (inputDate) => {
  let formDate = new Date(inputDate);
  var formatedDate = "";
  var date = formDate.getDate();
  var month = formDate.getMonth() + 1;
  var year = formDate.getFullYear();

  return (formatedDate = `${year}-${month < 10 ? 0 : ""}${month}-${date < 10 ? 0 : ""
    }${date}`);
};

export const getDateInBySplitYYYYMMDD = (inputDate) => {
  var splittedDate = inputDate.slice(0, 10).split(" ").join("-");

  let formDate = new Date(splittedDate);
  console.log("formDate,", formDate);
  var formatedDate = "";
  var date = formDate.getDate();
  console.log("date,", date);
  var month = formDate.getMonth() + 1;
  var year = formDate.getFullYear();
  formatedDate = `${year}-${month < 10 ? 0 : ""}${month}-${date < 10 ? 0 : ""
    }${date}`;
  console.log("formatedDate,", formatedDate);
  return formatedDate;
};

// =============================================== Time ========================================= //

export const convertTimeInMinutes = (time) => {
  var totalMinuts = time.getHours() * 60 + time.getMinutes();
  return totalMinuts;

  // var arr = time.split(":").map((item) => Number(item));
  // var minuts = arr[0] * 60 + arr[1];
  // return minuts;
};

export const totalEnteredTime = (totalEnteredTime) => {
  var splittedArr = totalEnteredTime.split(":");
  var totalMinutes = Number(splittedArr[0]) * 60 + Number(splittedArr[1]);

  var hours = totalMinutes / 60;
  var rhours = Math.floor(hours);
  var minute = (hours - rhours) * 60;
  var rminutes = Math.round(minute);

  let res = `${rhours < 10 ? 0 : ""}${rhours}:${rminutes < 10 ? 0 : ""
    }${rminutes}`;

  return res;
};

export const minutesInHors = (minutes) => {
  var hours = minutes / 60;
  var rhours = Math.floor(hours);
  var minute = (hours - rhours) * 60;
  var rminutes = Math.round(minute);

  let res = `${rhours < 10 ? 0 : ""}${rhours}:${rminutes < 10 ? 0 : ""
    }${rminutes}`;

  return res;
};

export const setWorkHrs = (enteredTime) => {
  var hours = enteredTime?.getHours();
  var minutes = enteredTime?.getMinutes();
  var totalTime = `${hours}:${minutes}`;
  return totalTime;
};

export const convertMinutesInTime = (time) => {
  var splittedStr = time.split(":");
  let dt = new Date();
  dt.setHours(Number(splittedStr[0]), Number(splittedStr[1]));
  return dt;
};

export const displayTime = (minutes) => {
  var hours = minutes / 60;
  var rhours = Math.floor(hours);
  var minute = (hours - rhours) * 60;
  var rminutes = Math.round(minute);

  let dt = new Date();
  dt.setHours(rhours, rminutes);
  return {
    hours: dt.getHours(),
    minutes: dt.getMinutes(),
  };
};

export const punchedTime = (time) => {
  let splittedArr = time ? (time + "").split(".") : "00:00";
  let hours = Number(splittedArr[0]);
  let minutes = splittedArr[1] ? splittedArr[1] : "00";
  let convertedMintes = minutes?.includes("0") ? minutes : `${minutes}${0}`;
  let punchedTime = `${hours < 10 ? 0 : ""}${hours}:${convertedMintes}`;
  // let punchedTime = `${hours < 10 ? 0 : ""}${hours}:${minutes < 10 ? 0 : ""}${minutes}`
  return time !== 0 ? punchedTime : "";
};

// ========================================= Week Days =========================================== //

export const getWeekDay = (day) => {
  const weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  let weekDay = weekday[new Date(day).getDay()];

  return weekDay;
};

// ================================ Count days for Leaves ====================================== //
export const daysCount = (date1, date2) => {
  let diffDays = 0;
  let startDate = new Date(date1);
  let EndDate = new Date(date2);
  while (startDate <= EndDate) {
    const dayOfWeek = startDate.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      diffDays++;
    }
    startDate.setDate(startDate.getDate() + 1);
  }
  return diffDays;
};

// ================================ Count days for Project Calc ====================================== //
export const projectHoursCount = (date1, date2) => {
  let diffDays = 0;
  let startDate = new Date(date1);
  let EndDate = new Date(date2);
  while (startDate <= EndDate) {
    const dayOfWeek = startDate.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      diffDays++;
    }
    startDate.setDate(startDate.getDate() + 1);
  }
  return diffDays * 8;
};

// ======================== Entered Hours should not greater than Punched Hours ======================= //

export const isEnteredHours = (totalPunchedTime, totalEnteredTime) => {
  var splittedArr = (totalPunchedTime + "").split(".");
  var totalMinutes = Number(splittedArr[0]) * 60 + Number(splittedArr[1]);

  var trueOrFalse = totalEnteredTime > totalMinutes ? true : false;
  return trueOrFalse;
};

export const convertTimeIn24Format = (timeString) => {
  let splittedTime = timeString.split(":");
  let hours = Number(splittedTime[0]);
  let minutes = Number(splittedTime[1]);
  let timeFormat = splittedTime[2];
  let formattedHours = timeFormat.includes("PM") ? hours + 12 : hours;
  let time = `${formattedHours < 10 ? 0 : ""}${formattedHours}:${minutes < 10 ? 0 : ""
    }${minutes}`;
  let convertedTimeIn24Format = time ? time : "00:00";
  return convertedTimeIn24Format;
};

// FormData
export const sendAsFormData = (data) => {
  console.log("data", data);
  let formdata = new FormData();

  for (let key in data) {
    formdata.append(key, data[key]);
  }

  return formdata;
};

export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export const convertTo12HourFormat = (timeStr) => {
  let [hours, minutes, seconds, ampm] = timeStr.split(":");
  let hour = parseInt(hours);

  let period = hour < 12 ? "AM" : "PM";

  if (hour === 0) {
    hour = 12;
  } else if (hour > 12) {
    hour -= 12;
  }

  return `${hour}:${minutes}:${seconds}:${period}`;
};

export const emojiReactions = [
  {
    label: "Like",
    id: "1",
    node: <div>👍</div>,
    emoji: "👍",
  },
  {
    label: "Smile",
    id: "2",
    node: <div>🙂</div>,
    emoji: "🙂",
  },
  {
    label: "laugh",
    id: "3",
    node: <div>🤣</div>,
    emoji: "🤣",
  },
  {
    label: "Surprised",
    id: "4",
    node: <div>😲</div>,
    emoji: "😲",
  },
  {
    label: "Thinking",
    id: "5",
    node: <div>🧐</div>,
    emoji: "🧐",
  },
  {
    label: "Heart",
    id: "6",
    node: <div>❤️</div>,
    emoji: "❤️",
  },
];

export const formatTime = (time) => {
  if (!time) return "";

  const [timePart, period] = time.split(" ");

  let [hours, minutes] = timePart.split(":");

  hours = parseInt(hours, 10);
  hours = hours % 12 || 12;
  minutes = parseInt(minutes, 10);

  // Determine if it's AM or PM
  const suffix = period.toLowerCase();

  return `${hours}:${minutes < 10 ? "0" + minutes : minutes} ${suffix}`;
};

export const formatTimes = (dateString) => {
  const date = new Date(dateString.replace(/T/, " "));

  const options = {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
  };

  return date.toLocaleTimeString("en-US", options);
};

export const countMessage = (arr, key) => {
  let t = 0;

  arr.forEach((i) => {
    t += Number(i[key]);
  });

  return (
    t > 0 && (
      <span
        class="badge"
        style={{
          position: "relative",
          marginLeft: "-2px",
        }}
      >
        {t}
      </span>
    )
  );
};

export const convertMinutesIntoHours = (minutes) => {
  let hours = Math.floor(minutes / 60);

  let remaining = minutes % 60;
  return `${hours} : ${remaining}`;
};

export const emailValidation = (email) => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailPattern.test(email);
};

export const strongPassword = (password) => {
  const passwordRegex = /^(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/;

  return passwordRegex.test(password);
}

export const diffDate = (start, end) => {
  start = new Date(start);

  end = new Date(end);
  let Difference_In_Time = end.getTime() - start.getTime();

  return Math.round(Difference_In_Time / (1000 * 3600 * 24));
};


export const formatDate = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}


export const validUrl = (url) => {

  const urlRegex = /^(https?):\/\/[^\s/$.?#].[^\s]*$/i;
  return urlRegex.test(url);

}

export const makeSelectOptions = (arr, lableKey, valkey) => {

  return arr.map((i) => {
    return {
      label: i[lableKey],
      value: i[valkey],
      item: i
    }
  })

}

export const simpleHandleChange = (key, val, func) => {

  func(prev => ({
    ...prev,
    [key]: val
  }))

}

export const handlwValidationRequired = (obj, notRequiredField, setValided) => {

  let isValided = true

  let keys = Object.keys(obj)

  keys.forEach((i, index) => {

    if ((!obj[i] && !obj?.length) && !notRequiredField.includes(i)) {

      console.log(i, obj[i])

      setValided(true)

      isValided = false;

    }

  })

  return isValided


}

export function isValidLatLng(lnglat) {
  const latitudeRegex = /^(-?([1-8]?[0-9]{1,2}(\.\d{6,})?|90(\.0000000+)?))$/;

  return latitudeRegex.test(lnglat);
}


export const compareDate = (date) => {

  let currentDate = new Date()

  currentDate.setHours(0, 0, 0, 0);

  date = date?.split('/').reverse().join('-')

  const givenDate = new Date(date)

  givenDate.setHours(0, 0, 0, 0)


  return givenDate < currentDate


}


export const isHaveSpecialCharecter = (str) => {

  const specialCharRegex = /[^a-zA-Z0-9]/;
  return specialCharRegex.test(str);

}

export const checkOnlyNumbers = (str) => {

  const onlyNumbersRegex = /^[0-9]+$/;
  return onlyNumbersRegex.test(str);
}






//  Pristan Code 
export const isEmptyObject = (obj) => {
  return Object.keys(obj).length === 0;
};

export const roundedOff = (value) => {
  var decimalValue = value - Math.floor(value);
  return decimalValue.toFixed(2);
};

export const toFixedValue = (value) => {
  let res = 0;
  return (res = Math.round(value * 100) / 100);
};

export function formatCurrency(amount, locale = 'en-US', currencyCode = 'INR') {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
  }).format(amount);
}



export const getDateyyyymmdd = (date) => {
  let formDate = new Date(date);
  var day = formDate.getDate();
  var month = formDate.getMonth() + 1;
  var year = formDate.getFullYear();

  var formatedDate = `${year}/${month < 10 ? "0" : ""}${month}/${day < 10 ? "0" : ""
    }${day}`;
  return formatedDate && formatedDate;
};

export const getDatemmddyyy = (inputeDate) => {
  let formDate = new Date(inputeDate);
  var date = formDate.getDate();
  var month = formDate.getMonth() + 1;
  var year = formDate.getFullYear();

  const formatedDate = `${month < 10 ? "0" : ""}${month}/${date < 10 ? "0" : ""
    }${date}/${year}`;
  return formatedDate;
};

export const displayDateFormat = (dateForm, date) => {
  if (dateForm === "MM/dd/yyyy") {
    let convertedDate = getDatemmddyyy(date);
    return convertedDate;
  } else if (dateForm === "yyyy/MM/dd") {
    let convertedDate = getDateyyyymmdd(date);
    return convertedDate;
  } else {
    let convertedDate = getDateddmmyyyy(date);
    return convertedDate;
  }
};

export const productOnChangeHandler = (
  e,
  setInvoiceDetails,
  invoiceDetails,
  index,
  isStateSame,
  appSettings
) => {
  const { name } = e.target;
  const discountType = appSettings?.discType === "Amount" ? true : false;
  if (name === "qty") {
    setInvoiceDetails(
      invoiceDetails.map((item, innerIndex) => {
        let calculatedDiscount = discountType
          ? item.discPer
          : (item.discPer * Number(e.target.value) * item.rate) / 100;
        console.log("calculatedDiscount-qty,", calculatedDiscount);
        let disCountAmount = Math.max(
          Number(e.target.value) * item.rate - calculatedDiscount,
          0
        );
        return index === innerIndex
          ? {
            ...item,
            qty: Number(e.target.value),
            discAmount: toFixedValue(disCountAmount),
            cgstAmount: isStateSame
              ? toFixedValue(disCountAmount * (item.cgst / 100))
              : 0,
            sgstAmount: isStateSame
              ? toFixedValue(disCountAmount * (item.sgst / 100))
              : 0,
            igstAmount: isStateSame
              ? 0
              : toFixedValue(disCountAmount * (item.igst / 100)),
          }
          : item;
      })
    );
  } else if (name === "rate") {
    setInvoiceDetails(
      invoiceDetails.map((item, innerIndex) => {
        let calculatedDiscount = discountType
          ? item.discPer
          : (item.discPer * Number(e.target.value) * item.qty) / 100;
        console.log("calculatedDiscount-rate,", calculatedDiscount);
        let disCountAmount = Math.max(
          Number(e.target.value) * item.qty - calculatedDiscount,
          0
        );
        return index === innerIndex
          ? {
            ...item,
            rate: Number(e.target.value),
            discAmount: toFixedValue(disCountAmount),
            cgstAmount: isStateSame
              ? toFixedValue(disCountAmount * (item.cgst / 100))
              : 0,
            sgstAmount: isStateSame
              ? toFixedValue(disCountAmount * (item.sgst / 100))
              : 0,
            igstAmount: isStateSame
              ? 0
              : toFixedValue(disCountAmount * (item.igst / 100)),
          }
          : item;
      })
    );
  } else if (name === "unitId") {
    setInvoiceDetails(
      invoiceDetails.map((item, innerIndex) => {
        return index === innerIndex
          ? {
            ...item,
            unitId: Number(e.target.value),
          }
          : item;
      })
    );
  } else if (name === "discPer") {
    setInvoiceDetails(
      invoiceDetails.map((item, innerIndex) => {
        let calculatedDiscount = discountType
          ? Number(e.target.value)
          : discountType
            ? Number(e.target.value)
            : (Number(e.target.value) * item.rate * item.qty) / 100;
        console.log("calculatedDiscount-discPer,", calculatedDiscount);
        let disCountAmount = item.rate * item.qty - calculatedDiscount;
        return index === innerIndex
          ? {
            ...item,
            discPer: Number(e.target.value),
            discAmount: toFixedValue(disCountAmount),
            cgstAmount: isStateSame
              ? toFixedValue(disCountAmount * (item.cgst / 100))
              : 0,
            sgstAmount: isStateSame
              ? toFixedValue(disCountAmount * (item.sgst / 100))
              : 0,
            igstAmount: isStateSame
              ? 0
              : toFixedValue(disCountAmount * (item.igst / 100)),
          }
          : item;
      })
    );
  } else if (name === "cgst") {
    setInvoiceDetails(
      invoiceDetails.map((item, innerIndex) => {
        return index === innerIndex
          ? {
            ...item,
            cgst: Number(e.target.value),
            cgstAmount: toFixedValue(
              (Number(e.target.value) * item.discAmount) / 100
            ),
            igst: 0,
            igstAmount: 0,
          }
          : item;
      })
    );
  } else if (name === "sgst") {
    setInvoiceDetails(
      invoiceDetails.map((item, innerIndex) => {
        return index === innerIndex
          ? {
            ...item,
            sgst: Number(e.target.value),
            sgstAmount: toFixedValue(
              (Number(e.target.value) * item.discAmount) / 100
            ),
            igst: 0,
            igstAmount: 0,
          }
          : item;
      })
    );
  } else if (name === "igst") {
    setInvoiceDetails(
      invoiceDetails.map((item, innerIndex) => {
        // let calculatedDiscount = (Number(e.target.value) * item.discAmount) / 100
        // let disCountAmount = item.discAmount - calculatedDiscount
        return index === innerIndex
          ? {
            ...item,
            igst: Number(e.target.value),
            igstAmount: toFixedValue(
              (Number(e.target.value) * item.discAmount) / 100
            ),
            cgst: 0,
            sgst: 0,
            cgstAmount: 0,
            sgstAmount: 0,
          }
          : item;
      })
    );
  }
};
export const singleProductHandler = (...parameter) => {
  const [
    product,
    index,
    setBackDropOpen,
    setInvoiceDetails,
    invoiceDetails,
    isStateSame,
    appSettings,
    isService = false
  ] = parameter;
  setBackDropOpen(true);

  let url = isService ? ApiConfig.GET_SERVICES_LIST_API : ApiConfig.GET_PRODUCT_DETAILS
  simpleGetCallWithToken(url + `/${product.id}`)
    .then((res) => {
      if (res.success) {
        setBackDropOpen(false);
        (index + 1 == invoiceDetails.length) && setInvoiceDetails([
          ...invoiceDetails.map((item, innerIndex) => {
            if (innerIndex === index)
              return {
                productId: res.data.id,
                ...calculate({ ...res.data }),
              };
            else return item;
          }),
          {
            id: 0,
            hsnId: 0,
            productId: 0,
            gst: 0,
            gstAmount: 0,
            igst: 0,
            igstAmount: 0,
            sgst: 0,
            sgstAmount: 0,
            cgst: 0,
            cgstAmount: 0,
            discPer: 0,
            discAmount: 0,
            unitId: 0,
            productName: "",
            hsnCode: "",
            qty: 0,
            rate: 0,
          },
        ]);
      } else {
        console.log(res.json.message);
        setBackDropOpen(false);
      }
    })
    .catch((err) => console.log(err));

  const calculate = (item) => {
    let cgstAmount = isStateSame
      ? (item.qty * item.rate * (item.cgst || item.taxRate / 2)) / 100
      : 0;
    let sgstAmount = isStateSame
      ? (item.qty * item.rate * (item.cgst || item.taxRate / 2)) / 100
      : 0;
    let igstAmount = isStateSame
      ? 0
      : (item.qty * item.rate * (item.igst || item.taxRate)) / 100;

    return {
      ...item,
      cgst: isStateSame ? item.cgst || item.taxRate / 2 : 0,
      sgst: isStateSame ? item.sgst || item.taxRate / 2 : 0,
      igst: 18, //isStateSame ? 0 : item.igst || item.taxRate
      cgstAmount: toFixedValue(cgstAmount),
      sgstAmount: toFixedValue(sgstAmount),
      igstAmount: toFixedValue(igstAmount),
      discAmount: toFixedValue(item.qty * item.rate),
      amount: 0,
      discPer: item.discPer ? item.discPer : 0,
      unitId: item.unitId ? item.unitId : 15,
    };
  };
};

const formatTimesDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);

  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata", // Converts UTC → IST
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};